module.exports = "<app-navigation></app-navigation>\n<div class=\"\" id=\"transform-app\">\n    <router-outlet></router-outlet>\n</div>"